export class ProfileViewApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Upsert profile view.
     * @returns any
     * @throws ApiError
     */
    upsert({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/profile_view',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
